import { render } from "./SmartBanking.vue?vue&type=template&id=ee004dd6"
import script from "./SmartBanking.vue?vue&type=script&lang=js"
export * from "./SmartBanking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__